import { useState } from "react";
import Button from "../buttons/button/Button";
import { BUTTON_TYPES } from "../buttons/button/ButtonTypes";
import { getLoyaltySDK } from "../../api/loyaltySdk";
import { setCustomerLoyaltyConsent } from "../../utils/loyalty/loyaltySdkUtils";
import { logError, ERROR_TYPE } from "../../utils/newRelicLogger";
import { LOYALTY_CONSENT_STATUS } from "../../constants";
import LoyaltySuccessModal from "./LoyaltySuccessModal";
import { useRuntimeConstants } from "../../context/runtimeConstants/RuntimeConstantsContext";
import { fireJoinAsosWorldButtonClickAnalytics } from "../../analytics/pageInteraction";

const JoinAsosWorldButton = () => {
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const { isMixAndMatch, getTranslation } = useRuntimeConstants();
  const buttonText = getTranslation("loyalty_join_asos_world_button");

  const handleClick = async () => {
    fireJoinAsosWorldButtonClickAnalytics();
    try {
      const loyaltySdk = await getLoyaltySDK();
      const success = await setCustomerLoyaltyConsent(
        loyaltySdk,
        LOYALTY_CONSENT_STATUS.OPTED_IN
      );
      if (success) {
        setShowSuccessModal(true);
      }
    } catch (error) {
      if (error.name !== "LoyaltyNotSupportedError") {
        logError(ERROR_TYPE.SdkError, {
          sdk: "loyalty",
          action: "setCustomerLoyaltyConsent",
          message: error.message,
        });
      }
    }
  };

  const closeModal = () => {
    setShowSuccessModal(false);
    window.location.reload();
  };

  return (
    <>
      <Button
        type={
          isMixAndMatch ? BUTTON_TYPES.loyaltyFullWidth : BUTTON_TYPES.loyalty
        }
        handleClick={handleClick}
        ariaLabel={buttonText}
      >
        <div>{buttonText}</div>
      </Button>
      <LoyaltySuccessModal open={showSuccessModal} closeModal={closeModal} />
    </>
  );
};

export default JoinAsosWorldButton;
